import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChangePassword } from "../components/ChangePassword";
import { ROLE_LABELS, useApp } from "../context/AppContext";

export function SettingsPage() {
  const { user, tenantId, setTenantId, signOut } = useApp();
  const [tenantInput, setTenantInput] = useState(tenantId);
  const navigate = useNavigate();

  const onSwitchTenant = (e) => {
    e.preventDefault();
    const next = tenantInput.trim();
    if (next && next !== tenantId) {
      setTenantId(next);
      navigate("/", { replace: true });
    }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h1 className="text-2xl font-semibold">Settings</h1>
        <p className="text-sm text-slate-500">Account and tenant preferences.</p>
      </div>

      <section className="card space-y-3">
        <h2 className="text-lg font-semibold">Account</h2>
        {user ? (
          <dl className="grid grid-cols-3 gap-y-2 text-sm">
            <dt className="text-slate-500">Display name</dt>
            <dd className="col-span-2 font-medium">{user.display_name || user.user_id}</dd>
            <dt className="text-slate-500">Email</dt>
            <dd className="col-span-2 font-mono text-xs">{user.email || "—"}</dd>
            <dt className="text-slate-500">User ID</dt>
            <dd className="col-span-2 font-mono text-xs">{user.user_id}</dd>
            <dt className="text-slate-500">Tenant</dt>
            <dd className="col-span-2 font-mono text-xs">{user.tenant_id}</dd>
            <dt className="text-slate-500">Roles</dt>
            <dd className="col-span-2">{user.roles.map((r) => ROLE_LABELS[r] ?? r).join(", ")}</dd>
            <dt className="text-slate-500">Status</dt>
            <dd className="col-span-2">{user.status}</dd>
          </dl>
        ) : (
          <p className="text-sm text-slate-500">Not signed in.</p>
        )}
        <div>
          <button
            type="button"
            className="btn-secondary"
            onClick={() => {
              signOut();
              navigate("/login", { replace: true });
            }}
          >
            Sign out
          </button>
        </div>
      </section>

      <section className="card space-y-3">
        <h2 className="text-lg font-semibold">Active tenant</h2>
        <p className="text-sm text-slate-500">
          Switch the tenant scope used by API calls. You will only see data for tenants you have access to.
        </p>
        <form onSubmit={onSwitchTenant} className="flex gap-2">
          <input
            className="input"
            value={tenantInput}
            onChange={(e) => setTenantInput(e.target.value)}
            placeholder="tenant id"
          />
          <button type="submit" className="btn-primary" disabled={!tenantInput.trim() || tenantInput.trim() === tenantId}>
            Switch
          </button>
        </form>
        <p className="text-xs text-slate-500">Currently active: <span className="font-mono">{tenantId}</span></p>
      </section>
      <ChangePassword />
    </div>
  );
}
